/**
 * Returns a human-readable "Inherit (N)" or "Inherit (N unit)" label for
 * slider positions that represent "no override; inherit the global default".
 *
 * Used by:
 *  - ScanIntensitySection list rows (formatHostsValue / formatRateValue)
 *  - SingleScanProfileForm sliders (unlimitedLabel)
 */
export function formatInheritLabel(
  inheritedDefault: number,
  unit?: string
): string {
  return unit
    ? `Inherit (${inheritedDefault} ${unit})`
    : `Inherit (${inheritedDefault})`;
}
